import { useUser } from "@clerk/tanstack-react-start";
import posthog from "posthog-js";
import { useEffect, useRef } from "react";

import { writeClientTutorialCompleted } from "#/lib/tutorialCompletion";
import { markTutorialCompleted } from "#/server/markTutorialCompleted";

export function useMarkTutorialCompletedOnFinish(isFinal: boolean): void {
  const { isSignedIn } = useUser();
  const hasMarkedRef = useRef(false);

  useEffect(() => {
    if (!isFinal || hasMarkedRef.current) return;
    hasMarkedRef.current = true;
    writeClientTutorialCompleted();
    posthog.capture("tutorial_completed");
    if (!isSignedIn) return;
    void markTutorialCompleted({ data: {} }).catch(() => {
      hasMarkedRef.current = false;
    });
  }, [isFinal, isSignedIn]);
}
